import { createApp } from 'vue'
import Toast from '@/views/Component/Toast'
let toastDom = null
let app = null
const toast = options => {
  const page = document.querySelector('.main-container')
  const dom = page.querySelector('.my-toast')
  if (dom) {
    app.unmount()
  } else {
    // 创建元素节点
    toastDom = document.createElement('div')
    // 给元素设置class
    toastDom.className = 'my-toast'
    // 在body标签内部插入此元素
    page.appendChild(toastDom)
  }
  // 创建应用实例（第一个参数是根组件。第二个参数可选，它是要传递给根组件的 props）
  app = createApp(Toast, {
    ...options,
    hide() {
      if (app) {
        // 卸载实例
        app.unmount()
        app = null
      }
      if (toastDom) {
        // 删除dom
        page.removeChild(toastDom)
        toastDom = null
      }
    }
  })
  // 将应用实例挂载到创建的 DOM 元素上
  return app.mount(toastDom)
}
// 注册插件app.use()会自动执行install函数
toast.install = app => {
  // 注册全局属性，类似于 Vue2 的 Vue.prototype
  app.config.globalProperties.$toast = options => toast(options)
}

export default toast
